import { Outlet } from 'react-router'

import { SideMenu, Header, ScrollToTopBtn } from '../../components'
import { useCommonFetchs } from '../../hooks'
import { useAtomValue } from 'jotai'
import * as state from '../../states'

export const AuthLayout = () => {
	const isMenuOpen = useAtomValue(state.menuIsOpenAtom)
	const { errors } = useCommonFetchs({ silentMode: true })
	const { errorAccountBuyers, errorOfferGroups, errorAffiliateNetwork, errorCountry } = errors
	//TODO: use isDev condition if necessary
	//const isDev: boolean = !/^production$/i.test(process.env?.NODE_ENV ?? '')

	return <>
		<SideMenu/>

		<div className={`main-content-area ${isMenuOpen ? 'hide-sidemenu-area' : ''}`}
		     style={{
			     justifyContent: 'flex-start'
		     }}>
			<div className="container-fluid">
				<Header/>
				<Outlet/>
			</div>
		</div>

		<ScrollToTopBtn/>
	</>
}
